export default {
    //   API_BASE_URL: "http://localhost:4000/graphql",
    API_BASE_URL: "https://api-staging.dermaster.asia/graphql",
};
